import React, { MouseEventHandler, useContext, useState } from 'react';
import { Icon } from '../../images/Icon/Icon';
import { Tooltip } from '../../actions/Tooltip';
import { IconsEnum } from '../../../constants/icons';
import uuidGen from '../../../helpers/uuidGen';
import { DevDebugContext } from '../../../providers/DevDebugProvider';
import { Modal } from '../Modal';
import classes from './Debugger.module.scss';
import classNames from 'classnames';
import scssVars from '../../../assets/scss/exportedVars.module.scss';

export const DebuggerView = (props: { tooltipContent: string; modalContent?: object | string }): JSX.Element => {
  // const [modalContent, setModalContent] = useState('');
  const [tooltipId] = useState<string>(uuidGen());
  const { debugMode } = useContext(DevDebugContext);
  const [showModal, setShowModal] = useState<boolean>(false);

  if (!debugMode) {
    return <></>;
  }

  const hasModalContent = props.modalContent !== undefined;
  const closeModal = () => setShowModal(false);
  const openModal: MouseEventHandler = e => {
    e.stopPropagation();
    hasModalContent && setShowModal(true);
  };

  return (
    <>
      <span
        data-tooltip-debug-id={tooltipId}
        onClick={openModal}
        className={classNames(classes.Icon, hasModalContent ? classes.IconClickable : '')}>
        <Icon name={IconsEnum.debugger} size={'medium'} />
      </span>
      <Tooltip
        type={'regular'}
        position={'right'}
        style={{ zIndex: scssVars['z-index-overmodal'], maxWidth: '100%' }}
        target={`[data-tooltip-debug-id="${tooltipId}"]`}>
        <pre>{props.tooltipContent}</pre>
      </Tooltip>
      {showModal && (
        <Modal size={'large'} showCloseIcon={true} closeOnClickOutside={true} closeOnEsc={true} onClose={closeModal}>
          <pre className={classes.Pre}>{JSON.stringify(props.modalContent, null, 4)}</pre>
        </Modal>
      )}
    </>
  );
};
